import { useEffect, useState, useRef } from "react";
import { getSentry } from "../../helpers/get-sentry";
import { t } from "i18next";

export default function SentryFeedbackButton({
  id = "feedback-button",
  className = "",
  children,
}) {
  const buttonRef = useRef(null);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    setFeedback(getSentry().getFeedback());
  }, []);

  useEffect(() => {
    if (feedback && buttonRef.current) {
      feedback.attachTo(buttonRef.current, {
        triggerLabel: t("feedback.triggerLabel"),
        triggerAriaLabel: t("feedback.triggerAriaLabel"),
        formTitle: t("feedback.formTitle"),
        submitButtonLabel: t("feedback.submitButtonLabel"),
        cancelButtonLabel: t("feedback.cancelButtonLabel"),
        confirmButtonLabel: t("feedback.confirmButtonLabel"),
        addScreenshotButtonLabel: t("feedback.addScreenshotButtonLabel"),
        removeScreenshotButtonLabel: t("feedback.removeScreenshotButtonLabel"),
        nameLabel: t("feedback.nameLabel"),
        namePlaceholder: t("feedback.namePlaceholder"),
        emailLabel: t("feedback.emailLabel"),
        emailPlaceholder: t("feedback.emailPlaceholder"),
        isRequiredLabel: t("feedback.isRequiredLabel"),
        messageLabel: t("feedback.messageLabel"),
        messagePlaceholder: t("feedback.messagePlaceholder"),
        successMessageText: t("feedback.successMessageText"),
      });
    }
  }, [feedback, t]);

  return (
    <button
      id={id}
      ref={buttonRef}
      type="button"
      className={`${className}`}
    >
      {children || t("feedback.formTitle")}
    </button>
  );
}
